var React = require('react');

function IconInfoBlack (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"icon-background","data-name":"Ellipse 699","cx":"12","cy":"12","r":"12","key":0}),React.createElement("g",{"id":"Group_2021","data-name":"Group 2021","transform":"translate(11 6)","key":1},React.createElement("g",{"id":"Group_2022","data-name":"Group 2022"},[React.createElement("line",{"id":"Line_204","data-name":"Line 204","y2":"7","transform":"translate(1 6)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","key":0}),React.createElement("circle",{"id":"Ellipse_701","data-name":"Ellipse 701","cx":"1","cy":"1","r":"1","fill":"#fff","key":1})]))]);
}

IconInfoBlack.defaultProps = {"id":"Group_2076","data-name":"Group 2076","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconInfoBlack;

IconInfoBlack.default = IconInfoBlack;
